import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationLoader = () => {
  const { isImpersonationLoading } = useAuth();

  if (!isImpersonationLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-8 shadow-2xl max-w-sm w-full mx-4"
      >
        <div className="flex flex-col items-center">
          {/* Animated Icon Container */}
          <div className="relative mb-6">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              className="absolute inset-0 w-20 h-20 border-4 border-blue-200 rounded-full border-t-blue-600"
            />
            <div className="w-20 h-20 flex items-center justify-center">
              <UserCheck className="w-10 h-10 text-blue-600" />
            </div>
          </div>

          {/* Loading Text */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            Switching User Account
          </h3>
          <p className="text-sm text-gray-600 text-center mb-4">
            Please wait while we set up your session...
          </p>

          {/* Loading Dots Animation */}
          <div className="flex space-x-2">
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                animate={{
                  y: ["0%", "-50%", "0%"],
                }}
                transition={{
                  duration: 0.6,
                  repeat: Infinity,
                  delay: index * 0.1,
                }}
                className="w-2 h-2 bg-blue-600 rounded-full"
              />
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ImpersonationLoader;